import React, { useEffect } from 'react'
import ModalLayout from '../../../layout/ModalLayout'
import { useDispatch, useSelector } from 'react-redux'
import { showCityModalFunc } from '../../../../config/redux/slice/adminSlice'
import { get_delete_request, post_put_patch_request } from '../../../../helpers/request'
import { app_api } from '../../../../utils/endpoints/app_api'
import Spinner from '../../../components/Spinner'
import { clearAll, onUpdate, setCustomerErrorMessage, setCustomerLoading, setListingValues, setOrderValues, showListingModalFunc, showOrderModalFunc } from '../../../../config/redux/slice/customerSlice'

export default function ConfirmDelivery() {
    const dispatch = useDispatch()
    const {
        customerLoading,
      orderManagement:{singleOrderDetails, orderItemsData}
    } = useSelector((state) => state.customer)

    const {
        token
    } = useSelector((state) => state.authData)

    const onSubmit = async () => {
        dispatch(clearAll({}))
        const res = await post_put_patch_request(
          "patch",
            token,
            `${app_api.confirm_delivery(singleOrderDetails?.id, 'BUYER')}`,
            {},
            dispatch,
            setCustomerLoading,
            "",
            setCustomerErrorMessage
        )
        if(res !== undefined && res.status < 400){
          let newOrderDetails = [...orderItemsData];
          let filteredOrderDetails = newOrderDetails.map((opt)=> {
            if(opt.id === singleOrderDetails.id){
              return {...opt, ...res?.data?.data}
            }else {
              return opt
            }
          })
          dispatch(onUpdate({message: res?.data?.message, type: 'order'}))
          dispatch(setOrderValues({propertyKey: 'orderItemsData', value: filteredOrderDetails}))
        }
    }

    const closeModal = () => {
      dispatch(showOrderModalFunc({modal: false, type: null}))
    }

  return (
    <ModalLayout onClick={closeModal} heading={'Confirm Delivery'}>
        <div className="modal-body">
            <p>Confirming delivery means you have received your order.</p>
        </div>
        <div className="modal-footer border-top-0 d-flex align-items-center">
            <div>
            {customerLoading ? 
                <Spinner isForm={true}/> :
                <button onClick={onSubmit} type="button" className="btn btn-success me-3">Confirm</button>
            }
            </div>
            <button disabled={customerLoading ? true : false} onClick={closeModal} type="button" className="btn btn-info">Cancel</button>
        </div>
    </ModalLayout>
  )
}
